export default function Rust_IfElse() {
  return (
    <div>
      <h1>Rust_IfElse Component</h1>
      <p>This is the Rust_IfElse page.</p>
    </div>
  );
}
